export default __webpack_public_path__ + "static/media/ardrive3.04666ece.png";